import styled from "styled-components";
import { MdEdit } from "react-icons/md";
import { FaEye, FaTrash } from "react-icons/fa";
import useModal from "../../hooks/useModal";

interface ActionsProps {
  id: string;
  classe: string;
  operations?: number
}

function Actions({ id, classe, operations }: ActionsProps) {

  const {
    setId,
    setIsOpen,
    setIsEditing,
    setIsDeleting,
    setClasse,
    setIsOperacoesOpen,
  } = useModal();

  function handleOpenModal() {
    setId(id);
    setIsEditing(true);
    setIsOpen(true);
  }

  function handleOpenOperacoesModal() {
    setId(id);
    setClasse(classe);
    setIsOperacoesOpen(true);
  }

  function handleOpenDeleteModal() {
    if (operations) return;
    setId(id);
    setClasse(classe);
    setIsDeleting(true);
  }

  return (
    <Container>
      <IconContainer>
        <MdEdit size={18} color="#757575" onClick={handleOpenModal} />
      </IconContainer>

      <IconContainer>
        <FaEye size={18} color="#757575" onClick={handleOpenOperacoesModal} />
      </IconContainer>

      <IconContainerTrash operations={!!operations}>
        <FaTrash size={18} color="#757575" onClick={handleOpenDeleteModal} />
      </IconContainerTrash>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

const IconContainer = styled.div`
  padding: 6px;
  border-radius: 5px;
  background-color: #f5f5f5;
  cursor: pointer;
`;

const IconContainerTrash = styled(IconContainer)<{ operations: boolean }>`
  cursor: ${({ operations }) => (!operations ? "pointer" : "not-allowed")};

  svg {
    color: ${({ operations }) => (!operations ? "rgba(117, 117, 117)" : "rgb(189, 189, 189)")} !important;
  }
`;

export default Actions;
